import { render } from "./ProfileIcon.vue?vue&type=template&id=20e07d45&bindings={}"
import script from "./ProfileIcon.vue?vue&type=script&lang=ts"
export * from "./ProfileIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script